import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Icon } from '@ferris/react/components/icon';
import Input from '@ferris/react/components/forms/Input';
import { Tooltip } from '@ferris/react/components/tooltip';

const FormInput = ({
    id,
    label,
    type,
    value,
    changeHandler,
    error,
    handleBlur,
    min,
    max
}) => (
    <Input
        id={`${id}-input`}
        classes="property_details__form"
        fullWidth
        label={label}
        type={type}
        isControlled
        floatLabel
        data-wdio={`${id}-input`}
        value={value}
        onChange={changeHandler}
        invalid={error && error.length}
        validationMessage={error || ''}
        onBlur={handleBlur}
        aria-label={label}
        aria-invalid={!!error}
        max={max}
        min={min}
        formControlProps={
            { id: `${id}-input` }
        }
    />
);

FormInput.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    changeHandler: PropTypes.func.isRequired,
    error: PropTypes.string,
    handleBlur: PropTypes.func.isRequired,
    min: PropTypes.number,
    max: PropTypes.number
};
FormInput.defaultProps = {
    error: '',
    min: null,
    max: null
};

export const Label = ({
    message, className, precedingText = ''
}) => (
    <React.Fragment>
        { /* eslint-disable-next-line react/jsx-one-expression-per-line */ }
        <span>{precedingText}</span><span className="property_details__no-wrap">&#65279;<Tooltip
            position="bottom"
            text={message}
            classes={className}
        >
            <Icon name="info-outline" color="interactive" size="medium" />
            { /* eslint-disable-next-line react/jsx-closing-tag-location */ }
        </Tooltip></span>

    </React.Fragment>
);

Label.propTypes = {
    message: PropTypes.string.isRequired,
    className: PropTypes.string,
    precedingText: PropTypes.string
};
Label.defaultProps = {
    className: '',
    precedingText: ''
};

const PDField = ({
    fieldProps,
    labelProps
}) => (
    <div className={cn('property_details__form')}>
        <FormInput {...fieldProps} />
        { labelProps && (<Label {...labelProps} />)}
    </div>
);

PDField.propTypes = {
    fieldProps: FormInput.propTypes.isRequired,
    labelProps: Label.propTypes.isRequired
};

export default PDField;
